import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LoaderService } from '../../../services/loader.service';
import { UnterrichtszeitService } from '../../../services/facetten/instance/unterrichtszeit.service';

import { CheckboxFacetteComponent } from '../../checkbox-facette/checkbox-facette.component';
import { FilterSelectItem } from '../../checkbox-facette/checkbox-liste/filterSelectItem';
import { BasisFacetteComponent } from '../basis-facette/basis-facette.component';

@Component({
  selector: 'now-wbsuche-lib-unterrichtszeit-facette',
  templateUrl: './unterrichtszeit-facette.component.html',
  imports: [CheckboxFacetteComponent, BasisFacetteComponent, CommonModule]
})
export class UnterrichtszeitFacetteComponent {
  facettenService = inject(UnterrichtszeitService);
  loaderService = inject(LoaderService);

  public expanded$ = this.facettenService.expanded$;
  public items$ = this.facettenService.getSelectItems$();

  public updateSelectedIds(selectedItems: FilterSelectItem[]): void {
    const selectedIds = selectedItems.map((item) => item.key);
    this.facettenService.updateSelectedIds(selectedIds);
  }
}
